/* eslint-disable camelcase */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';

import LoadImage from '../../components/LoadImage';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';


class RemoveMedia extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    t: PropTypes.func,
    media: PropTypes.shape({
      url: PropTypes.string,
      projects: PropTypes.array,
      unitLayouts: PropTypes.array,
      data: PropTypes.shape({
        thumbnail_url: PropTypes.string,
        thumbnail_url_with_play_button: PropTypes.string,
      }),
    }),
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    headerNode: PropTypes.node,
    type: PropTypes.oneOf(['delete', 'remove']),
  }
  shouldComponentUpdate(nextProps) {
    if ((JSON.stringify(this.props.media) !== JSON.stringify(nextProps.media)) ||
    (JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data)) ||
    (this.props.open !== nextProps.open)) {
      return true;
    }
    return false;
  }
  getThumbnailUrl = (media = this.props) => {
    if (media && media.data && media.data.thumbnail_url) {
      return media.data.thumbnail_url;
    }
    return '';
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnConfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e);
    }
  }
  renderWarning() {
    const { media, t } = this.props;
    if (this.props.type === 'delete' && media) {
      if (media.projects || media.unitLayouts) {
        const projectLength = media.projects ? media.projects.length : 0;
        const layoutLength = media.unitLayouts ? media.unitLayouts.length : 0;
        return (
          <h3>{t('This video is used in {{count}} place(s).', { ns: TRANSLATION_FILES.translation, count: projectLength + layoutLength })}</h3>
        );
      }
    }
    return null;
  }
  render() {
    const { t } = this.props;
    const thumbnailUrl = this.getThumbnailUrl();
    return (
      <Modal
        basic
        open={this.props.open === true}
        onClose={this.handleOnClose}
      >
        <Header icon="warning sign" content={this.props.headerNode || t(`Confirm ${this.props.type || 'remove'}?`, { ns: TRANSLATION_FILES.translation })} />
        <Modal.Content image>
          <LoadImage
            wrapped
            src={thumbnailUrl}
          />
          <Modal.Description>
            {this.renderWarning()}
            <h3>{t(`Are you sure to ${this.props.type || 'remove'} this video`, { ns: TRANSLATION_FILES.translation })}{
                this.props.type !== 'delete' && this.props.data ? ` ${t('from', { ns: TRANSLATION_FILES.screens })} ${this.props.data.name}` : ''}?</h3>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={this.handleOnClose} icon="cancel" content={t('No', { ns: TRANSLATION_FILES.constants })} inverted />
          <Button basic positive onClick={this.handleOnConfirm} icon={this.props.type === 'delete' ? 'trash' : 'checkmark'} content={t('Yes', { ns: TRANSLATION_FILES.constants })} inverted />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(RemoveMedia);



// WEBPACK FOOTER //
// ./src/containers/modals/RemoveMedia.jsx